// extracted by mini-css-extract-plugin
export default {"wrapper":"text-box_wrapper__dyeXC","boxText":"text-box_boxText__Gasjf","mask":"text-box_mask__1GzHy"};